import { Modal } from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
  // Retrieve modal-related elements
  const modalElement = document.getElementById('confirmationModal');
  const modalBodyElement = document.getElementById('confirmationModalBody');
  const confirmButton = document.getElementById('confirmButton');

  // Ensure required elements are available
  if (!modalElement || !modalBodyElement || !confirmButton) {
    console.error('Modal or its elements not found in the DOM.');
    return;
  }

  // Initialize Bootstrap modal
  const bootstrapModal = new Modal(modalElement);

  // Event delegation for buttons/inputs with `data-wf-confirmation`
  document.body.addEventListener('click', (event) => {
    const target = event.target as HTMLElement;

    // Ensure the clicked element is a button or input
    const tagValid = (target.tagName === 'BUTTON' || target.tagName === 'INPUT');
    if (tagValid && target.hasAttribute('data-wf-confirmation') && (target as HTMLInputElement).type === 'submit') {
      event.preventDefault();

      // Find the closest form for the clicked button/input
      const form = target.closest('form');
      if (!form) {
        console.error('No form found for the clicked button/input.');
        return;
      }

      // Retrieve the confirmation message
      const confirmationText = target.getAttribute('data-wf-confirmation') || 'Are you sure you want to submit the form?';
      modalBodyElement.innerHTML = confirmationText;

      // Set up confirm button to submit the form
      confirmButton.onclick = () => {
        form.submit(); // Submit the form
        bootstrapModal.hide(); // Hide the modal
      };

      // Show the modal
      bootstrapModal.show();
    }
  });
});
